import usersService from './users.service';

const GetUsersPageLimit = 60,

 createUser = (
  {
    email,
    name,
    name_of_site,
  }: {
    email: string;
    name: string;
    name_of_site: string;
  }
) => usersService.createUser(
    {
      Username: email,
      MessageAction: 'SUPPRESS',
      UserAttributes: [
        {
          Name: 'name',
          Value: name,
        },
        {
          Name: 'email',
          Value: email,
        },
        {
          Name: 'custom:name_of_site',
          Value: name_of_site,
        },
        {
          Name: 'custom:role',
          Value: 'user',
        },
        {
          Name: 'custom:approved',
          Value: '0',
        },
        {
          Name: 'custom:send_email',
          Value: 'true',
        },
      ],
    }
  ),

 getUsers = (
  {
    pageSize,
    paginationToken,
    searchText,
    userAction,
    usersLoaded = 0,
  }: {
    pageSize?: number;
    paginationToken?: string;
    searchText?: string;
    userAction?: boolean;
    usersLoaded?: number;
  }
) => {

  const searchBy = `name ^= '${searchText}'`,

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   params: any = {
    Filter: searchText && searchBy,
  };

  if (userAction) {

    if (usersLoaded <= GetUsersPageLimit) {

      params.Limit = usersLoaded;

} else {

      params.Limit = GetUsersPageLimit;

}

} else {

    params.Limit = pageSize;

}

  if (paginationToken) {

    params.PaginationToken = paginationToken;

}

  return usersService.getUsers(params);

},

 resendWelcomeEmail = (
  username: string
) => usersService.resendWelcomeEmail(username),

 approveUser = (
  username: string) => usersService.adminUpdateUserAttributes(
    {
      Username: username,
      UserAttributes: [
        {
          Name: 'custom:approved',
          Value: '1',
        },
      ],
    }
  ),

 disableUser = (
  username: string) => usersService.adminDisableUser(
    {
      Username: username,
    }
  ),

 enableUser = (
  username: string
) => usersService.adminEnableUser(
    {
      Username: username,
    }
  ),

 changeUserEmail = (
  currentEmail: string,
  newEmail: string) => usersService.adminUpdateUserAttributes(
    {
      UserAttributes: [
        {
          Name: 'email',
          Value: newEmail,
        },
        {
          Name: 'email_verified',
          Value: 'false',
        },
      ],
      Username: currentEmail,
    },
  ),

 toggleUserSendEmail = (
  username: string,
  value: string
) => usersService.adminUpdateUserAttributes(
    {
      Username: username,
      UserAttributes: [
        {
          Name: 'custom:send_email',
          Value: value,
        },
      ],
    },
  );

export default {
  createUser,
  getUsers,
  resendWelcomeEmail,
  approveUser,
  disableUser,
  enableUser,
  changeUserEmail,
  toggleUserSendEmail,
};
